
const subjects = [
    {
    id: 1,
    subject: 'Mathematics',
    name: 'Mathematics',
    icon: '📐',
    color: '#3498db',
  },
  {
    id: 2,
    subject: 'Physics',
    name: 'Physics',
    icon: '🧲',
    color: '#2ecc71',
  },
  {
    id: 3,
    subject: 'Chemistry',
    name: 'Chemistry',
    icon: '⚗️',
    color: '#9b59b6',
  }

];

export default subjects;